/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AccountControllerDtoAccountInventoryInfoAccountInventoryGears model module.
 * @module model/AccountControllerDtoAccountInventoryInfoAccountInventoryGears
 * @version 1.0
 */
class AccountControllerDtoAccountInventoryInfoAccountInventoryGears {
    /**
     * Constructs a new <code>AccountControllerDtoAccountInventoryInfoAccountInventoryGears</code>.
     * @alias module:model/AccountControllerDtoAccountInventoryInfoAccountInventoryGears
     */
    constructor() { 
        
        AccountControllerDtoAccountInventoryInfoAccountInventoryGears.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AccountControllerDtoAccountInventoryInfoAccountInventoryGears</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AccountControllerDtoAccountInventoryInfoAccountInventoryGears} obj Optional instance to populate.
     * @return {module:model/AccountControllerDtoAccountInventoryInfoAccountInventoryGears} The populated <code>AccountControllerDtoAccountInventoryInfoAccountInventoryGears</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AccountControllerDtoAccountInventoryInfoAccountInventoryGears();

            if (data.hasOwnProperty('nftUid')) {
                obj['nftUid'] = ApiClient.convertToType(data['nftUid'], 'Number');
            }
            if (data.hasOwnProperty('grade')) {
                obj['grade'] = ApiClient.convertToType(data['grade'], 'Number');
            }
            if (data.hasOwnProperty('active')) {
                obj['active'] = ApiClient.convertToType(data['active'], 'Boolean');
            }
            if (data.hasOwnProperty('activeAt')) {
                obj['activeAt'] = ApiClient.convertToType(data['activeAt'], 'Date');
            }
            if (data.hasOwnProperty('expiredAt')) {
                obj['expiredAt'] = ApiClient.convertToType(data['expiredAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AccountControllerDtoAccountInventoryInfoAccountInventoryGears</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AccountControllerDtoAccountInventoryInfoAccountInventoryGears</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Number} nftUid
 */
AccountControllerDtoAccountInventoryInfoAccountInventoryGears.prototype['nftUid'] = undefined;

/**
 * @member {Number} grade
 */
AccountControllerDtoAccountInventoryInfoAccountInventoryGears.prototype['grade'] = undefined;

/**
 * @member {Boolean} active
 */
AccountControllerDtoAccountInventoryInfoAccountInventoryGears.prototype['active'] = undefined;

/**
 * @member {Date} activeAt
 */
AccountControllerDtoAccountInventoryInfoAccountInventoryGears.prototype['activeAt'] = undefined;

/**
 * @member {Date} expiredAt
 */
AccountControllerDtoAccountInventoryInfoAccountInventoryGears.prototype['expiredAt'] = undefined;






export default AccountControllerDtoAccountInventoryInfoAccountInventoryGears;

